<template>
  <div>
    <!-- <h4>История контактов</h4> -->

    <template v-if="!isComplete">
      Загружается...
    </template>
    <template v-else-if="items.length > 0">
      <table class="table-custom">

        <thead>
        <tr>
          <th width="5%"></th>
          <th>Организация</th>
          <th>Дата</th>
          <th>Контактное лицо</th>
          <th>Контакты</th>
          <th>Итог общения</th>
        </tr>
        </thead>

        <tbody>
        <tr v-for="(item) in items" v-bind:key="item.id" v-on:dblclick="editCard(item.id)">
          <td>
            <menu-component class="actions" :actions="actions(item)"/>
          </td>
          <td>{{ item.vacancy.name }}</td>
          <td>{{ $momentFormat(item.dateMeeting, "DD.MM.YYYY") }}</td>
          <td>{{ item.contactPerson }}</td>
          <td>{{ item.contactInfo }}</td>
          <td>{{ item.result }}</td>

        </tr>
        </tbody>
      </table>
    </template>
    <template v-else>
      <EmptyListMessage/>
    </template>

    <div class="mt-2">
      <button-component v-if="canEdit" @click='editCard(0)'>Создать</button-component>
    </div>

    <section class="modals">
      <modal-component v-if="modals.show" title="История контактов" @close="modals.show = false">
        <applicant-history-card :applicant-id="applicantId" :card-id="modals.id" :is-readonly="modals.isReadonly"
                                @close="modals.show = false" @save="modals.show = false;loadPage();"/>
      </modal-component>
    </section>

  </div>
</template>
<script>
import API from '../api/applicantHistory'
import Constants from '@/common/constants'
import ModalComponent from "@/common/ui/ModalComponent";
import ApplicantHistoryCard from '../views/ApplicantHistoryCard.vue';
import MenuComponent from "../../../common/ui/components/page/MenuComponent";
import ButtonComponent from '@/common/ui/ButtonComponent'


export default {
  name: "ApplicantTabHistory",
  components: {
    MenuComponent,
    ApplicantHistoryCard,
    ModalComponent,
    ButtonComponent
  },
  props: {
    applicantId: Number,
    canEdit: Boolean
  },
  data: () => ({
    items: [],
    isComplete: false,
    modals: {
      show: false,
      id: null,
      isReadonly: false
    }
  }),
  created() {
    this.loadPage();
  },
  watch: {
    applicantId: function (/*newValue, oldValue*/) {
      this.loadPage();
    }
  },
  methods: {
    actions(item) {
      let result = [{
        title: 'Просмотр',
        icon: 'eye',
        click: () => this.viewCard(item.id)
      }];
      if (this.canEdit) {
        result = result.concat([
          {
            title: 'Редактировать',
            icon: 'pen',
            click: () => this.editCard(item.id)
          },
          {
            title: 'Удалить',
            icon: 'trash',
            click: () => this.deleteCard(item.id)
          }
        ]);
      }
      return result;
    },
    loadPage() {
      if (this.applicantId > 0) {
        var self = this;
        self.isComplete = false;
        API.search(this.applicantId).then(function (response) {
          self.items = response.data;
          self.isComplete = true;
        });
      }
    },
    viewCard(id) {
      this.modals.id = id;
      this.modals.show = true;
      this.modals.isReadonly = true;
    },
    editCard(id) {
      if (this.canEdit) {
        this.modals.id = id;
        this.modals.show = true;
        this.modals.isReadonly = false;
      } else {
        this.viewCard(id);
      }
    },
    deleteCard(id) {
      var self = this;
      Constants.alert.fire(Constants.confirmOptions.delete).then((res) => {
        if (res.isConfirmed) {
          API.delete(id).then(function (response) {
            Constants.alert.fire('Удаление', response.data.message, response.data.success ? 'success' : 'error');
            self.loadPage();
          })
        }
      });
    },
  },
};
</script>
